// extracted by mini-css-extract-plugin
module.exports = {"FooterContainer":"Footer_FooterContainer__1E6KN","copyrightMessage":"Footer_copyrightMessage__2Y-EM"};